import { format, formatISO, parseISO, startOfDay } from "date-fns";
import { SCHEDULE_DATE_FORMAT } from "./serviceTemplateSchedule.constants";

export function formatServiceTemplateScheduleOccurrenceCalendarDate(
    value: string,
): string {
    return format(parseISO(value), SCHEDULE_DATE_FORMAT);
}

export function formatServiceTemplateScheduleOccurrenceDate(
    value: string,
): string {
    const today = formatISO(startOfDay(new Date()), {
        representation: "date",
    });
    if (value === today) {
        return "Today";
    }
    return formatServiceTemplateScheduleOccurrenceCalendarDate(value);
}

export function formatServiceTemplateScheduleOccurrenceDayOfWeek(
    value: string,
): string {
    return format(parseISO(value), "EEEE");
}
